import { createSlice } from "@reduxjs/toolkit";

const tokenSlice = createSlice({
    name: 'usuario',
    initialState: {
        tokenEmpresa: [],
        tokenAdmin: []
    },
    reducers: {
        addTokenEmpresa: (state, action) => {
            state.tokenEmpresa = action.payload
        },
        addTokenAdmin: (state, action) => {
            state.tokenAdmin = action.payload
        },
    }
});

export const { addTokenEmpresa, addTokenAdmin } = tokenSlice.actions;
export default tokenSlice.reducer;